import { apiPost } from './api';
import { ENDPOINTS } from '../config/api';

// Login user and store token
export const loginUser = async (email, password) => {
  try {
    const data = await apiPost(ENDPOINTS.LOGIN, { username:email, password });

    if (data.access) {
      // Store the access token
      localStorage.setItem('adminToken', data.access);
      // Store the refresh token
      localStorage.setItem('adminRefreshToken', data.refresh);
      // Store user data
      localStorage.setItem('adminUser', JSON.stringify({
        email: data.email,
        name: data.full_name || data.first_name || data.email,
        role: data.role,
        firstName: data.first_name,
        lastName: data.last_name,
        isActive: data.is_active,
        photo: data.photo
      }));
      return { success: true, user: data };
    }

    return {
      success: false,
      message: 'Échec de la connexion. Veuillez vérifier vos identifiants.'
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Échec de la connexion. Veuillez réessayer.'
    };
  }
};

// Logout user
export const logoutUser = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminRefreshToken');
  localStorage.removeItem('adminUser');
  window.location.href = '/login';
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('adminToken');
};

// Get current user
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('adminUser');
  if (!userStr) return null;

  try {
    return JSON.parse(userStr);
  } catch (error) {
    return null;
  }
};

// Check if user has required role
export const hasRole = (requiredRole) => {
  const user = getCurrentUser();
  if (!user) return false;

  // If requiredRole is an array, check if user has any of the roles
  if (Array.isArray(requiredRole)) {
    return requiredRole.includes(user.role);
  }

  // Otherwise check for specific role
  return user.role === requiredRole;
};
